import React, { FC, ReactNode } from 'react';
import TranslationContext from './TranslationContext';

type Props = {
  children: ReactNode;
  locale: string;
  messages: { [key: string]: string };
};

const TranslationProvider: FC<Props> = ({
  children,
  locale,
  messages
}): JSX.Element => (
  <TranslationContext.Provider value={{ locale, messages }}>
    {children}
  </TranslationContext.Provider>
);

export default TranslationProvider;
